import { render, staticRenderFns } from "./IndividualMatterGradesReportTable.vue?vue&type=template&id=49142313&scoped=true"
import script from "./IndividualMatterGradesReportTable.vue?vue&type=script&lang=js"
export * from "./IndividualMatterGradesReportTable.vue?vue&type=script&lang=js"
import style0 from "./IndividualMatterGradesReportTable.vue?vue&type=style&index=0&id=49142313&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49142313",
  null
  
)

export default component.exports